"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustodyTelemetryUploadRequest = exports.CustodyTelemetryRecord = void 0;
const zod_1 = require("zod");
const custody_telemetry_js_1 = require("./custody-telemetry.js");
const storage_pressure_js_1 = require("./storage-pressure.js");
/** Both records are protected, append-only telemetry, never weighing evidence. */
exports.CustodyTelemetryRecord = zod_1.z.union([custody_telemetry_js_1.RoutineDiscardSummary, storage_pressure_js_1.StoragePressureRecord]);
exports.CustodyTelemetryUploadRequest = zod_1.z
    .object({
    records: zod_1.z.array(exports.CustodyTelemetryRecord).min(1).max(64),
})
    .strict();
//# sourceMappingURL=custody-upload.js.map